// Textos del listado y la edición de usuarios WAIIS (user-list). Se registran junto al
// resto de vocabularios en AppComponent; setTranslation los fusiona.
export const locale = {
  lang: 'ca',
  data: {
    WAIIS_USER_LIST: {
      EXPORT_CSV: 'Exportar CSV',
      KPIS: {
        ARIA: 'Indicadors d\'usuaris',
        TOTAL: 'Usuaris totals',
        TOTAL_HINT: 'Comptes donats d\'alta a l\'app',
        NEW_7D: '+{{count}} en els últims 7 dies',
        ACTIVE_30D: 'Actius (30 dies)',
        ACTIVE_30D_HINT: 'Han obert l\'app l\'últim mes',
        DRIVERS: 'Conductors',
        DRIVERS_HINT: 'Amb vehicle donat d\'alta',
        BANNED: 'Bloquejats',
        BANNED_HINT: 'Comptes bloquejats per l\'equip',
        SHARE_OF_TOTAL: '{{pct}} del total',
        IN_TABLE: 'A la taula',
        SEE_IN_TABLE: 'Veure a la taula',
      },
      FILTERS: {
        SEARCH_PLACEHOLDER: 'Cerca nom, correu, telèfon o ID…',
        SEARCH_ARIA: 'Cercar usuari',
        TYPE_ARIA: 'Tipus',
        STATUS_ARIA: 'Estat',
        ACTIVITY_ARIA: 'Activitat',
        CLEAR: 'Netejar filtres',
        TYPE: {
          ALL: 'Tipus: tots',
          DRIVER: 'Conductors',
          NO_DRIVER: 'Sense vehicle',
          ADMIN: 'Administradors',
        },
        STATUS: {
          ALL: 'Estat: tots',
          NOT_BANNED: 'No bloquejats',
          BANNED: 'Bloquejats',
        },
        ACTIVITY: {
          ALL: 'Activitat: qualsevol',
          TODAY: 'Avui',
          LAST_7D: 'Últims 7 dies',
          LAST_30D: 'Últims 30 dies',
          INACTIVE_30D: 'Sense activitat en 30 dies',
        },
      },
      PANEL: {
        TITLE_DRIVERS: 'Conductors',
        TITLE_DRIVERS_BANNED: 'Conductors bloquejats',
        TITLE_NO_DRIVER: 'Usuaris sense vehicle',
        TITLE_ADMINS: 'Administradors',
        TITLE_BANNED: 'Usuaris bloquejats',
        TITLE_ACTIVE_30D: 'Usuaris actius (30 dies)',
        TITLE_ALL: 'Usuaris registrats',
        PART_ACTIVITY: 'activitat: {{value}}',
        PART_SEARCH: 'cerca «{{value}}»',
        SUB_FILTERED: 'Filtrat per {{filters}}. Fes clic en una fila per obrir-ne la fitxa.',
        SUB_ALL: 'Tots els comptes donats d\'alta a l\'app. Fes clic en una fila per obrir-ne la fitxa.',
      },
      TABLE: {
        LOADING: 'Carregant…',
        LOADING_USERS: 'Carregant usuaris',
        COL_CREATED: 'Alta',
        COL_USER: 'Usuari',
        COL_PHONE: 'Telèfon',
        COL_ROLE: 'Rol',
        COL_VERIFICATION: 'Verificació',
        COL_LAST_ACTIVITY: 'Última activitat',
        COL_STATUS: 'Estat',
        COL_OPEN: 'Obrir',
        VIEW_PROFILE: 'Veure fitxa',
        RETRY: 'Tornar-ho a provar',
        EMPTY_FILTERED: 'Cap usuari coincideix amb la cerca.',
        EMPTY: 'Encara no hi ha usuaris.',
        NO_ACTIVITY_RECORDED: 'Sense activitat registrada',
        NO_NAME: 'Sense nom',
      },
      ERRORS: {
        INVALID_FILTER: 'Algun filtre no és vàlid. Prova de netejar els filtres.',
        LOAD: 'No s\'ha pogut carregar el llistat d\'usuaris.',
      },
      PAGINATION: {
        SHOWING_ONE: 'Es mostra {{shown}} de {{total}} usuari',
        SHOWING_OTHER: 'Es mostren {{shown}} de {{total}} usuaris',
        PREV: 'Anterior',
        NEXT: 'Següent',
        PREV_ARIA: 'Pàgina anterior',
        NEXT_ARIA: 'Pàgina següent',
        PER_PAGE: '{{count}} per pàgina',
        PER_PAGE_ARIA: 'Usuaris per pàgina',
      },
      ROLE: {
        ADMIN: 'Admin',
        BUSINESS: 'Empresa',
        APP: 'App',
      },
      STATUS: {
        BANNED: 'Bloquejat',
        ACTIVE: 'Actiu',
      },
      CHECKS: {
        PHONE_ON: 'Telèfon verificat',
        PHONE_OFF: 'Telèfon sense verificar',
        DOCUMENT_ON: 'Document verificat',
        DOCUMENT_OFF: 'Document sense verificar',
        LICENSE_ON: 'Carnet verificat',
        LICENSE_OFF: 'Carnet sense verificar',
      },
      AGO: {
        NEVER: 'Mai',
        NOW: 'Ara',
        MINUTES: 'Fa {{count}} min',
        HOURS: 'Fa {{count}} h',
        YESTERDAY: 'Ahir',
        DAYS: 'Fa {{count}} dies',
        MONTHS_ONE: 'Fa 1 mes',
        MONTHS_OTHER: 'Fa {{count}} mesos',
        OVER_YEAR: 'Fa més d\'un any',
      },
    },
    USER_EDIT: {
      TITLE: 'Editar usuari',
      SUBTITLE: 'Dades del compte de l\'usuari.',
      SUBTITLE_WHO: 'Dades del compte de {{name}}.',
      BACK: 'Tornar a la fitxa',
      LOADING: 'Carregant l\'usuari',
      CANCEL: 'Cancel·lar',
      SAVE: 'Desar els canvis',
      SAVING: 'Desant…',
      SECTIONS: {
        PERSONAL: 'Dades personals',
        PERSONAL_SUB: 'Nom i dades bàsiques de la persona.',
        CONTACT: 'Contacte i compte',
        CONTACT_SUB: 'Com s\'identifica a l\'app i en quin idioma la fa servir.',
        DOCUMENT: 'Document',
        DOCUMENT_SUB: 'Document d\'identitat i CAE.',
        PROFESSIONAL: 'Perfil professional',
        PROFESSIONAL_SUB: 'El que veuen altres persones de la comunitat.',
        PREFERENCES: 'Preferències',
        PREFERENCES_SUB: 'Subscripcions i estat del compte.',
      },
      FIELDS: {
        NAME: 'Nom',
        SURNAME: 'Cognom',
        GENDER: 'Gènere',
        BIRTH_DATE: 'Data de naixement',
        EMAIL: 'Correu electrònic',
        PHONE: 'Telèfon',
        ROLE: 'Rol',
        LANGUAGE: 'Idioma',
        DOCUMENT_TYPE: 'Tipus de document',
        DOCUMENT: 'Document',
        CAE: 'CAE',
        PROFESSION: 'Professió',
        RELATED_COMPANY: 'Empresa relacionada',
        LINKEDIN: 'URL de LinkedIn',
        DESCRIPTION: 'Descripció',
        SUBSCRIBE: 'Subscriure\'s',
        NEWSLETTER: 'Subscrit al butlletí',
        AVAILABLE: 'Disponible',
        VIRTUAL: 'Virtual',
      },
      SELECT: {
        ROLE: 'Selecciona un rol',
        LANGUAGE: 'Selecciona un idioma',
        GENDER: 'Selecciona un gènere',
        DOCUMENT_TYPE: 'Selecciona un tipus',
      },
      ROLES: {
        DRIVER_PARTICULAR: 'Conductor particular',
        DRIVER_COMPANY: 'Conductor d\'empresa',
        ADMIN: 'Administrador',
        LOGISTICS: 'Logística',
      },
      GENDERS: {
        M: 'Masculí',
        F: 'Femení',
        O: 'Altre',
      },
      DOCUMENT_TYPES: {
        DNI: 'DNI',
        NIE: 'NIE',
        PASSPORT: 'Passaport',
      },
      ERRORS: {
        REQUIRED: '{{field}} és obligatori',
        MIN_LENGTH: '{{field}} ha de tenir com a mínim {{min}} caràcters',
        EMAIL: 'Introdueix un correu electrònic vàlid',
        PATTERN: '{{field}} té un format no vàlid',
        INVALID: 'Camp no vàlid',
        ROLE_REQUIRED: 'El rol és obligatori',
        LANGUAGE_REQUIRED: 'L\'idioma és obligatori',
      },
      SWAL: {
        SUCCESS_TITLE: 'Usuari actualitzat',
        SUCCESS_TEXT: 'Els canvis s\'han desat correctament.',
        ERROR_TITLE: 'No s\'han pogut desar els canvis',
        LOAD_DATA_ERROR: 'Error en carregar les dades de l\'usuari',
        LOAD_ERROR: 'Error en carregar l\'usuari',
        UPDATE_ERROR: 'Error en actualitzar l\'usuari',
      },
    },
  },
};
